import VoicesPeopleAndPages from "../Components/Voices/Profiles/VoicesPeopleAndPages";

const VoicesPeoplePage = () => {
  return <VoicesPeopleAndPages />;
};

export default VoicesPeoplePage;
